import type { PropType } from 'virtual-vue';
import type { PickerOption, PickerFieldNames } from '../types';
import { DEFAULT_FIELD_NAMES } from '../types';

export const DEFAULT_PICKER_COLUMN_OPTIONS: PickerOption[] = [];
export const DEFAULT_PICKER_COLUMN_DEFAULT_INDEX = 0;
export const DEFAULT_PICKER_COLUMN_DISABLED = false;
export const DEFAULT_PICKER_COLUMN_VISIBLE_OPTION_NUM = 5;
export const DEFAULT_PICKER_COLUMN_OPTION_HEIGHT = 112;
export const DEFAULT_PICKER_COLUMN_SWIPE_DURATION = 150;
export const DEFAULT_PICKER_COLUMN_COLUMN_INDEX = 0;

/**
 * PickerColumn 组件的 props
 * 基于方案设计文档生成
 */
export const props = {
  /**
   * 当前列的选项数据
   * @default []
   */
  options: {
    type: Array as PropType<PickerOption[]>,
    default: () => DEFAULT_PICKER_COLUMN_OPTIONS,
  },
  /**
   * 当前选中值
   */
  value: {
    type: [String, Number] as PropType<string | number>,
    default: undefined,
  },
  /**
   * 默认选中项索引
   * @default 0
   */
  defaultIndex: {
    type: Number,
    default: DEFAULT_PICKER_COLUMN_DEFAULT_INDEX,
  },
  /**
   * 是否禁用
   * @default false
   */
  disabled: {
    type: Boolean,
    default: DEFAULT_PICKER_COLUMN_DISABLED,
  },
  /**
   * 可见选项个数
   * @default 5
   */
  visibleOptionNum: {
    type: Number,
    default: DEFAULT_PICKER_COLUMN_VISIBLE_OPTION_NUM,
  },
  /**
   * 选项行高度（单位与 @unit 对应）
   * @default 112
   */
  optionHeight: {
    type: Number,
    default: DEFAULT_PICKER_COLUMN_OPTION_HEIGHT,
  },
  /**
   * 惯性滚动时长（ms）
   * @default 150
   */
  swipeDuration: {
    type: Number,
    default: DEFAULT_PICKER_COLUMN_SWIPE_DURATION,
  },
  /**
   * 当前列的索引（多列时由父组件传入）
   * @default 0
   */
  columnIndex: {
    type: Number,
    default: DEFAULT_PICKER_COLUMN_COLUMN_INDEX,
  },
  /**
   * 自定义字段名
   * @default { text: 'text', value: 'value' }
   */
  columnsFieldNames: {
    type: Object as PropType<PickerFieldNames>,
    default: () => ({ ...DEFAULT_FIELD_NAMES }),
  },
};
